import { useState } from 'react';
import { Save } from 'lucide-react';

const ContentManager = () => {
  const [activeTab, setActiveTab] = useState('home');

  const tabs = [
    { id: 'home', label: 'Home Page' },
    { id: 'about', label: 'About Us' },
    { id: 'contact', label: 'Contact' },
  ];

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold text-slate-900">Content Management</h1>
        <button className="bg-orange-600 text-white px-4 py-2 rounded flex items-center hover:bg-orange-700 transition-colors">
          <Save size={18} className="mr-2" /> Save Changes
        </button>
      </div>

      <div className="bg-white rounded-lg shadow-sm border border-slate-100 overflow-hidden">
        <div className="border-b border-slate-200 flex">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-6 py-3 font-medium text-sm transition-colors ${
                activeTab === tab.id
                  ? 'border-b-2 border-orange-600 text-orange-600 bg-orange-50'
                  : 'text-slate-600 hover:text-slate-900 hover:bg-slate-50'
              }`}
            >
              {tab.label}
            </button>
          ))}
        </div>

        <div className="p-6">
          {activeTab === 'home' && (
            <div className="space-y-6">
              <div>
                <h3 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">Hero Section</h3>
                <div className="grid grid-cols-1 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1">Slide 1 Title</label>
                    <input type="text" className="w-full px-4 py-2 rounded border border-slate-300 focus:border-orange-500 outline-none" defaultValue="Advanced Manufacturing Excellence" />
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-slate-700 mb-1">Slide 1 Subtitle</label>
                    <input type="text" className="w-full px-4 py-2 rounded border border-slate-300 focus:border-orange-500 outline-none" defaultValue="State-of-the-art facilities delivering precision electrical components." />
                  </div>
                </div>
              </div>
              
              <div>
                <h3 className="text-lg font-bold text-slate-900 mb-4 border-b pb-2">About Preview</h3>
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-1">Heading</label>
                  <input type="text" className="w-full px-4 py-2 rounded border border-slate-300 focus:border-orange-500 outline-none" defaultValue="Leading Manufacturer of Electrical Solutions Since 1995" />
                </div>
              </div>
            </div>
          )}

          {activeTab === 'about' && (
            <div className="space-y-6">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Page Title</label>
                <input type="text" className="w-full px-4 py-2 rounded border border-slate-300 focus:border-orange-500 outline-none" defaultValue="About Us" />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Company Profile</label>
                <textarea rows={6} className="w-full px-4 py-2 rounded border border-slate-300 focus:border-orange-500 outline-none" defaultValue="ElectroMfg Corp is a leading manufacturer..." />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ContentManager;
